import { render, staticRenderFns } from "./popup-role.vue?vue&type=template&id=442dd8c2&scoped=true"
import script from "./popup-role.vue?vue&type=script&lang=js"
export * from "./popup-role.vue?vue&type=script&lang=js"
import style0 from "./popup-role.vue?vue&type=style&index=0&id=442dd8c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442dd8c2",
  null
  
)

export default component.exports